import { transform } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

if (typeof String.prototype.startsWith != 'function') {
  String.prototype.startsWith = function (prefix){
    return this.slice(0, prefix.length) === prefix;
  };
}
if (typeof String.prototype.endsWith != 'function') {
  String.prototype.endsWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
  };
}

function last(arr) {
  return arr[arr.length - 1];
}

export function trans({ topPassed, bottomPassed, progress }, source, target, preserveDigits = 0) {
  if (!topPassed) {
    return target[0];
  }
  if (bottomPassed || progress > last(source)) {
    return last(target);
  }
  return +transform(progress, source, target).toFixed(preserveDigits);
}

export function pureTrans(progress, source, target, preserveDigits = 0) {
  return +transform(progress, source, target).toFixed(preserveDigits);
}

export function clamp(min, value, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

export function useLoadImage(image, callback) {
  const ref = useRef();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const img = new Image();
    img.src = image;
    if (img.complete) {
      setLoaded(true);
      return;
    }
    img.onload = function() {
      setLoaded(true);
      if (callback) {
        callback();
      }
    };
    ref.current = img;
    return () => {
      if (ref.current) {
        ref.current.onload = () => {};
      }
    };
  }, [image, callback]);
  return loaded;
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const removeLeadingSlash = s => s.replace(/^\/+/g, '');

export function buildImageURL(path) {
  if (!path) {
    return 'INVALID';
  }
  const imgPath = process.env.NODE_ENV === 'development' ? 'img/' : 'zip/img/';
  let host = window.IMAGE_HOST || '/';
  host += host.endsWith('/') ? '' : '/';
  host += imgPath;
  if (path.startsWith('/')) {
    path = removeLeadingSlash(path);
  }
  return host + path;
}

export function getSeqFrames({ prefix: category, mobile, webpSupport, len, ext = 'jpg', startFrom = 0, digitLen }) {
  const _ext = webpSupport ? 'webp' : ext;
  const dir = mobile ? 'm' : 'd';
  if (!digitLen) {
    digitLen = len >= 100 ? 3 : 2;
  }

  let arr = [];
  if(Array.from){
    arr =  Array.from(new Array(len), (_, index) => {
      const i = startFrom + index;
      const paddedIndex = `${i}`.padStart(digitLen, 0);
      return buildImageURL(`/seq/${category}/${dir}/${paddedIndex}.${_ext}`);
    });
  }else{

    for(let i=0; i<len; i++){
      let ind = startFrom + i;
      let paddedIndex = digitLen > 2 ? `00${ind}` : `0${ind}`;
      let imgUrl = buildImageURL(`/seq/${category}/${dir}/${paddedIndex}.${_ext}`);
      arr.push(imgUrl);
    }
  }

  return arr;

}

// vivo requires single quotes, don't use this function
// export function getTrack({ product = 'X60 Pro', type = 'viewstate', block, total = 28 }) {
//   const track = {
//     type,
//     params: {
//       cform: '2204',
//       pagecode: '000',
//       product,
//       block,
//       total
//     }
//   };
//   return JSON.stringify(track);
// }

export function getTrack({ product = 'X60 Pro', type = 'viewstate', block, total = 30 }) {
  return `{'type':'${type}','params':{'cfrom':'2204','pagecode':'000','product':'${product}','block':'${block}','total':'${total}'}}`;
}

export function getButtonTrack({ position, pointsname }) {
  return `{'type':'click','params':{'pageview':'官网系列详情页','cfrom':'2204','name':'X60 Pro','type':'1','series':'X系列','position':'${position}','pointsname':'${pointsname}'}}`;
}

export function isIE() {
  if (!!window.ActiveXObject || "ActiveXObject" in window){
    return true;
  }else{
    return false;
  }
}